import { createSelector } from 'reselect';

import { getSportIdFromProps } from '../../../../selectors/_propsGetters_';
import { selectEntitiesMatchesEntityStatus } from '../../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { makeMatchTeamCompetitorPlayersArraySelector } from '../../../../selectors/match.selector';
import { type MatchStatus } from '../../../../types/match';
import { type SelectorMaker, type Selector } from '../../../../types/selectors';
import { SportIds, type SportId } from '../../../../types/sports';
import { createShallowEqualSelector } from '../../../../utils/reselect';

const emptyArray: [] = [];

type LineUpSubstitutesListPropsType = {
  playerIds: Array<number>;
  sportId?: SportId;
  matchStatus?: MatchStatus;
};

const makeLineUpSubstitutesListPropsSelector: SelectorMaker<LineUpSubstitutesListPropsType> = () => {
  const selectSubstitutePlayerIds: Selector<Array<number>> = createShallowEqualSelector(
    [makeMatchTeamCompetitorPlayersArraySelector(), getSportIdFromProps],
    (allPlayers, sportId) => {
      if (sportId === SportIds.ICEHOCKEY) {
        return emptyArray;
      }

      const substitutePlayers = [];

      for (let i = 0; i < allPlayers.length; i++) {
        const player = allPlayers[i];
        const { starter } = player;
        if (!starter) {
          substitutePlayers.push(player);
        }
      }

      return substitutePlayers
        .sort((playerA, playerB) => {
          const { displayOrder: playerADisplayOrder } = playerA;
          const { displayOrder: playerBDisplayOrder } = playerB;

          if (typeof playerADisplayOrder === 'number' && typeof playerBDisplayOrder === 'number') {
            return playerADisplayOrder - playerBDisplayOrder;
          }

          return 0;
        })
        .map(({ playerId }) => playerId)
        .filter((k) => k);
    },
  );

  return createSelector([selectSubstitutePlayerIds, selectEntitiesMatchesEntityStatus], (playerIds, matchStatus) => ({
    playerIds,
    matchStatus,
  }));
};

export default makeLineUpSubstitutesListPropsSelector;
